import { rbacManagementActions } from "../../constants/actionTypes";

const INITIAL_STATE = {
  rolesList: {},
  permissionsList: {},
  permissionsListError: {},
  rolePermissions: {},
  editRolePermissions: {},
  cloneRolesList: [],
  userActionData: {},
  resourceList: [],
  resourceListError: null,
  rolePermissionError: "",
  createRoleError: "",
  deleteActionData: "",
};

const rbacManagement = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case rbacManagementActions.ROLESLISTSETDATA:
      return {
        ...state,
        rolesList: {
          ...action.payload,
        },
        rolePermissions: {},
        editRolePermissions: {},
        userActionData: {},
      };
    case rbacManagementActions.PERMISSIONSLISTSETDATA:
      return {
        ...state,
        permissionsList: {
          ...action.payload,
        },
        rolesList: {},
      };
    case rbacManagementActions.PERMISSIONSLISTSETERROR:
      return {
        ...state,
        permissionsListError: {
          ...action.payload,
        },
      };
    case rbacManagementActions.ROLEPERMISSIONSSETDATA:
      return {
        ...state,
        rolePermissions: {
          ...action.payload,
        },
        rolesList: {},
      };
    case rbacManagementActions.ROLEPERMISSIONSEDITSUCCESS:
      return {
        ...state,
        editRolePermissions: {
          ...action.payload,
        },
        rolesList: {},
      };
    case rbacManagementActions.CREATENEWROLESUCCESS:
      return {
        ...state,
        rolesList: {
          ...state.rolesList,
          results: [...state.rolesList.results, action.payload],
          rolesList: {},
        },
      };
    case rbacManagementActions.USER_ACTION_SUCCESS:
      return {
        ...state,
        userActionData: action.payload,
      };
    case rbacManagementActions.ERROR_USER_ACTION_DATA:
      return {
        ...state,
        userActionData: action?.payload,
      };
    case rbacManagementActions.DELETE_ACTION_DATA:
      return {
        ...state,
        deleteActionData: action?.payload,
      };
    case rbacManagementActions.SET_CLONE_ROLES:
      return {
        ...state,
        cloneRolesList: Object.values(action?.payload)[0],
      };
    case rbacManagementActions.SET_RESOURCE_PERMISSIONS:
      return {
        ...state,
        resourceList: action?.payload?.data,
        resourceListError: null,
      };
    case rbacManagementActions.SET_RESOURCE_PERMISSIONS_ERROR:
      return {
        ...state,
        resourceListError: action?.payload?.data || action?.payload,
      };
    case rbacManagementActions.ROLEPERMISSIONSEDITERROR:
      return {
        ...state,
        rolePermissionError: action?.payload,
      };
    case rbacManagementActions.CREATENEWROLEERROR:
      return {
        ...state,
        createRoleError: action?.payload,
      };
    default:
      return state;
  }
};

export default rbacManagement;
